<template>
  <div>
    <v-tabs v-model="tab" color="black">
      <v-tab>
        List
      </v-tab>
      <v-tab>
        Grid
      </v-tab>
      <v-tab>
        Nested Grid
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <dnd-zone>
          <v-card
            max-width="400"
            class="mx-auto"
          >
            <v-system-bar
              color="grey darken-2"
              dark
            >
              <v-spacer></v-spacer>
              <v-icon>mdi-window-minimize</v-icon>
              <v-icon>mdi-window-maximize</v-icon>
              <v-icon>mdi-close</v-icon>
            </v-system-bar>
            <v-app-bar
              dark
              color="black"
            >
              <v-app-bar-nav-icon></v-app-bar-nav-icon>
              <v-toolbar-title>My Playlists</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-app-bar>
            <v-container>
              <dnd-container :dnd-model="cardModel.children" dnd-id="cards-example" class="row" dense vertical-search>
                <v-col cols="12" key="fixed">
                  <v-card
                    color="black"
                    dark
                  >
                    <v-card-title class="headline">
                      Bob Dylan
                    </v-card-title>
                    <v-card-actions>
                      <v-btn text>
                        <v-icon left>mdi-play</v-icon>
                        Play All
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <template v-for="item in cardModel.children">
                  <dnd-item :dnd-model="item" :key="item.id" :dnd-id="item.id">
                    <v-col
                      cols="12"
                    >
                      <v-card
                        color="white"
                      >
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title
                              class="headline"
                              v-text="item.title"
                            ></v-card-title>
                            <v-card-subtitle v-text="item.artist"></v-card-subtitle>
                            <v-card-actions>
                              <v-btn
                                class="ml-2 mt-3"
                                fab
                                icon
                                height="40px"
                                right
                                width="40px"
                              >
                                <v-icon>mdi-play</v-icon>
                              </v-btn>
                            </v-card-actions>
                          </div>
                          <v-avatar
                            class="ma-3"
                            size="125"
                            tile
                          >
                            <v-img :src="item.src"></v-img>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                  </dnd-item>
                </template>
              </dnd-container>
            </v-container>
          </v-card>
        </dnd-zone>
        <div>
          <v-alert
            color="grey darken-4"
            class="my-2"
            dark
            border="left"
            prominent
          >
<pre>
<code style="display: block;white-space: pre-wrap">
&lt;dnd-zone
  vertical-search
>
  &lt;dnd-container
    :dnd-model="cards"
    dnd-id="list-example"
    class="row"
  >
    &lt;template v-for="card in cards">
      &lt;dnd-item :dnd-model="card" :key="card.id" :dnd-id="card.id">
        &lt;v-col cols="12">
          &lt;!--Card Markup -->
        &lt;/v-col>
      &lt;/dnd-item>
    &lt;/template>
  &lt;/dnd-container>
&lt;/dnd-zone>
</code>
            </pre>
          </v-alert>
        </div>
      </v-tab-item>
      <v-tab-item class="pb-0">
        <v-card flat class="pb-10">
          <v-card-title><v-icon color="green" v-if="ordered">mdi-check</v-icon>Pai Mei GIF Captcha</v-card-title>
          <v-card-text>
            <dnd-zone :transition-duration="0.3">
              <dnd-container :dnd-model="images" dnd-id="images" class="row row--dense" style="max-width:500px;">
                <dnd-item
                  v-for="image in images"
                  :key="image.id"
                  :dnd-model="image"
                  :dnd-id="image.id"
                >
                  <v-col
                    class="d-flex child-flex handle"
                    :class="ordered ? 'pa-0' : 'pa-2'"
                    cols="4"
                  >
                    <v-img
                      :src="image.src"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </dnd-item>
              </dnd-container>
            </dnd-zone>
          </v-card-text>
          <v-card-actions style="max-width:500px;">
            <v-text-field
              label="E-mail"
              required
              :disabled="!ordered"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              class="ml-4"
              label="Password"
              required
              :disabled="!ordered"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              class="ml-4"
              :disabled="!ordered"
            >
              submit
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-alert
          color="grey darken-4"
          class="my-2 py-0"
          dark
          border="left"
          prominent
        >
<pre>
<code style="display: block;white-space: pre-wrap">
&lt;dnd-zone
  :transition-duration="0.3"
>
  &lt;dnd-container
    :dnd-model="images"
    dnd-id="grid-example"
    class="row"
    dense
  >
    &lt;dnd-item
      v-for="image in images"
      :key="image.id"
      :dnd-id="image.id"
      :dnd-model="image"
    >
      &lt;v-col cols="4">
        &lt;v-img :src="image.src"/>
      &lt;/v-col>
    &lt;/dnd-item>
  &lt;/dnd-container>
&lt;/dnd-zone>
</code>
          </pre>
        </v-alert>
      </v-tab-item>
      <v-tab-item>
        <dnd-zone
          handle-class="handle"
          :validate="validate"
          :native-scroll="false"
        >
          <recursive-grid
            :model="grid"
            @addChild="addChild"
            @edit="edit"
          />
        </dnd-zone>
      </v-tab-item>
    </v-tabs-items>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="290"
      >
        <v-card v-if="context">
          <v-card-title class="headline">
            Edit Note
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="context.title"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              @click="removeContext"
            >
              Delete Note
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="context = null"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
  import RecursiveGrid from '@/components/RecursiveGrid'
  import img_0 from '@/assets/0.gif'
  import img_1 from '@/assets/1.gif'
  import img_2 from '@/assets/2.gif'
  import img_3 from '@/assets/3.gif'
  import img_4 from '@/assets/4.gif'
  import img_5 from '@/assets/5.gif'
  import img_6 from '@/assets/dylan-0.jpg'
  import img_7 from '@/assets/dylan-1.jpg'
  import img_8 from '@/assets/dylan-2.jpg'
  import img_9 from '@/assets/dylan-3.jpg'
  export default {
    name: 'Examples',
    data: () => ({
      tab:0,
      context:null,
      selectedListItem: 1,
      noteCounter:1000,
      grid:{
        id:0,
        title:'KANBAN',
        color:'white',
        cols:12,
        level:0,
        dark:false,
        children:[
          {
            id:1,
            title:'Top Priority',
            color:'red darken-2',
            cols:4,
            level:1,
            dark:true,
            children:[],
          },
          {
            id:2,
            title:'Second Priority',
            color:'green darken-2',
            cols:4,
            level:1,
            dark:true,
            children:[],
          },
          {
            id:3,
            title:'Maybe some day',
            color:'blue darken-2',
            cols:4,
            level:1,
            dark:true,
            children:[],
          },
          {
            id:4,
            title:'Not in this lifetime',
            color:'purple darken-2',
            cols:4,
            level:1,
            dark:true,
            children:[],
          }
        ]
      },
      cardModel:{
        id:'card',
        children: [
          {
            id:'card-0',
            src: img_6,
            title: 'Blonde On Blonde',
            artist: 'Full Album',
          },
          {
            id:'card-1',
            src: img_7,
            title: "The Freewheelin'",
            artist: "Don't Think Twice, It's All Right",
          },
          {
            id:'card-2',
            src: img_8,
            title: 'Dylan',
            artist: 'Full Album',
          },
          {
            id:'card-3',
            src: img_9,
            title: "Live",
            artist: "Blowin' in the wind",
          },
        ],
      },
      listModel:{
        id:100,
        children:[
          {
            id:101,
            data:{
              text: 'Real-Time',
              icon: 'mdi-clock'
            }
          },
          {
            id:102,
            data:{
              text: 'Audience',
              icon: 'mdi-account'
            }
          },
          {
            id:103,
            data:{
              text: 'Conversions',
              icon: 'mdi-flag'
            }
          }
        ]
      },
      listModel2:{
        id:200,
        children:[
          {
            id:201,
            data:{
              text: 'Real-Time',
              icon: 'mdi-clock'
            }
          },
          {
            id:202,
            data:{
              text: 'Audience',
              icon: 'mdi-account'
            }
          },
          {
            id:203,
            data:{
              text: 'Conversions',
              icon: 'mdi-flag'
            }
          }
        ]
      },
      images:[
        {
          id:125,
          src:img_0
        },
        {
          id:126,
          src:img_1
        },
        {
          id:127,
          src:img_2
        },
        {
          id:128,
          src:img_3
        },
        {
          id:129,
          src:img_4
        },
        {
          id:130,
          src:img_5
        }
      ],
      dndModel:{
        id:94,
        children:[
          {
            id:1,
            children:[],
            data:{
              title:'A',
              content:'Lorem Ipsum',
              level:0
            },
          },
          {
            id:2,
            children:[
              {
                id:3,
                data:{
                  title:'B1',
                  content:'Lorem',
                  level:1
                },
                children:[]
              },
              {
                id:4,
                data:{
                  title:'B2',
                  content:'Lorem',
                  level:1
                },
                children:[]
              }
            ],
            data:{
              title:'B',
              content:'Lorem Ipsum',
              level:0
            },
          },
          {
            id:5,
            children:[
              {
                id:6,
                children:[],
                data:{
                  title:'0',
                  content:'Lorem',
                  level:1
                },
              },
              {
                id:7,
                children:[],
                data:{
                  title:'1',
                  content:'Lorem',
                  level:1
                },
              },
              {
                id:8,
                children:[],
                data:{
                  title:'2',
                  content:'Lorem',
                  level:1
                },
              },
              {
                id:9,
                children:[],
                data:{
                  title:'3',
                  content:'Lorem',
                  level:1
                },
              },
              {
                id:10,
                children:[],
                data:{
                  title:'4',
                  content:'Lorem',
                  level:1
                },
              },
              {
                id:11,
                children:[],
                data:{
                  title:'5',
                  content:'Lorem',
                  level:1
                },
              },
              {
                id:12,
                children:[],
                data:{
                  title:'6',
                  content:'Lorem',
                  level:1
                },
              }
            ],
            data:{
              title:'C',
              content:'Lorem Ipsum',
              level:0
            },
          }
        ]
      }
    }),
    computed:{
      dialog(){
        if(this.context){
          return true
        }else{
          return false
        }
      },
      ordered(){
        for (let i=0; i<this.images.length - 1; i++){
            if(this.images[i].id < this.images[i+1].id){
              return false
            }
        }
        return true
      }
    },
    methods:{
      validate(item, container, zone){
        if(item && container && zone){
          return item.dndModel.level - container.containerTransfer.level  == 1
        }
      },
      edit(model){
        this.context = model
      },
      removeContext(){
        this.grid.children.forEach(child=>{
          let index = child.children.indexOf(this.context)
          if (index > -1){
            child.children.splice(index,1)
          }
        })
        this.context = null
      },
      addChild(model){
        if (model.level == 1){
          model.children.unshift({
            id:this.noteCounter,
            title:'#' + this.noteCounter,
            color:'white',
            cols:6,
            class:{
              caption:true
            },
            level:2,
            dark:false,
            children:[],
          })
        }
        this.noteCounter++
      }
    },
    components:{RecursiveGrid}
  }
</script>
